import { Source } from "definitions/product-storage";

export type LinkPlatform =
  | typeof Source.Dewu
  | typeof Source.Shihuo
  | typeof Source.Goat;

export interface RecognizedLink {
  link: string;
  platform: LinkPlatform;
}

const PATTERNS: { platform: LinkPlatform; re: RegExp }[] = [
  { platform: Source.Dewu, re: /https:\/\/dw4\.co\/t\/A\/\w+/g },
  {
    platform: Source.Shihuo,
    re: /https:\/\/(?:www|m)\.shihuo\.cn\/\S*goodsId=\d+\S*/g,
  },
  {
    platform: Source.Goat,
    // продуктовый URL = /<категория>/<slug|id>: slug всегда с дефисом (brand-model-…-sku)
    // либо числовой productTemplateId; lookahead обрывает /g-матч на ?,#,пробеле или конце —
    // отсекает 3-сегментные и не-продуктовые ссылки
    re: /https:\/\/(?:www\.)?goat\.com\/[a-z0-9-]+\/(?:[a-z0-9]+(?:-[a-z0-9]+)+|\d+)(?=[?#\s]|$)/g,
  },
];

export const filterLinks = (input: string): RecognizedLink[] => {
  const seen = new Set<string>();
  const result: RecognizedLink[] = [];

  for (const { platform, re } of PATTERNS) {
    for (const link of input.match(re) ?? []) {
      if (seen.has(link)) continue;
      seen.add(link);
      result.push({ link, platform });
    }
  }

  return result;
};
